function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIconDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.488,
    height: 20,
    viewBox: "0 0 17.488 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1230",
    transform: "translate(-1191 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M15.405 17.273H.95a.931.931 0 0 1-.879-.584.913.913 0 0 1 .212-1.013l1.229-1.2V8.87a6.457 6.457 0 0 1 1.5-4.123 6.7 6.7 0 0 1 3.741-2.254V1.4a1.429 1.429 0 0 1 2.858 0v1.093c.105.022.2.045.293.069a4.5 4.5 0 0 0 4.949 6.972v4.938l1.229 1.2a.91.91 0 0 1 .212 1.01.94.94 0 0 1-.889.591z",
    transform: "translate(1191 27)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.818 1.818A1.817 1.817 0 0 0 3.636 0H0a1.817 1.817 0 0 0 1.818 1.818z",
    transform: "translate(1197.364 45.182)",
    style: {
      fill: "#203662"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1200.488 28.196)",
    style: {
      fill: "#ffc000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconDot);
export default __webpack_public_path__ + "static/media/bellIconDot.4bc30a305fe479d22dc3ad5485d64df4.svg";
export { ForwardRef as ReactComponent };